  document.addEventListener("DOMContentLoaded", function () {
    const scrollLinks = document.querySelectorAll('[data-scroll]');

    scrollLinks.forEach(link => {
      link.addEventListener('click', function (event) {
        event.preventDefault(); // Evita el comportamiento predeterminado del enlace.

        const targetId = this.getAttribute('href').substring(1); // Obtiene el ID del destino.
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Calcula la posición para centrar el elemento
          const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
          const offset = window.innerHeight / 2 - targetElement.offsetHeight / 2; // Centra en la ventana
          const centeredPosition = targetPosition - offset;

          // Desplazamiento suave al centro
          window.scrollTo({
            top: centeredPosition,
            behavior: 'smooth',
          });
        }
      });
    });
  });
